import React from 'react'
import {
  HowToFeedSafelyRoot,
  Header,
  HowToFeedSafelyContainer,
  ButtonWrapper,
} from './HowToFeedSafely.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import happyDog from '../../../../../public/assets/raw-benefits/happy-dog-and-owner.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'
import Link from 'next/link'
import { Button } from 'components/Button'
import Trans from 'next-translate/Trans'
import { TranslationKeys } from 'locales/translationKeys'

export const HowToFeedSafely: React.FC = () => {
  const { t } = useTranslation()

  const Copy = () => (
    <Stack className='copy-col' gap='3' direction='column'>
      <Text>{t('raw-benefits:how-to-feed-safely.body.0')}</Text>
      <Text><Trans i18nKey='raw-benefits:how-to-feed-safely.body.1' components={{
        Link: <Link href='blog/hppd-raw-food-the-safest-choice-for-your-pup' />
      }} /></Text>
      <Text>{t('raw-benefits:how-to-feed-safely.body.2')}</Text>
      <ul>
        {Array.from({ length: 6 }).map((_, i) => (
          <Text as="li" key={i}>{t(`raw-benefits:how-to-feed-safely.items.${i}` as TranslationKeys)}</Text>
        ))}
      </ul>
    </Stack>
  )

  return (
    <HowToFeedSafelyRoot>
      <HowToFeedSafelyContainer>
        <Header>{t('raw-benefits:how-to-feed-safely.title')}</Header>
        <ImageWithText
          copyColumn={<Copy />}
          imageSrc={happyDog}
          imageAlt="raw-benefits:how-to-feed-safely.image-alt"
          imageSide="right"
          isMobileImageBottom
        />
      </HowToFeedSafelyContainer>
    </HowToFeedSafelyRoot>
  )
}

HowToFeedSafely.displayName = 'HowToFeedSafely'

